<template>
  <modal :modal-id="modalId"
         modal-size="large"
         :title="selectedUrl ? $t('edit_transportation') : $t('add_transportation')"
         :preloader="preloader"
         @submit="submitData"
         @closeModal="closeModal">
    <template slot="body">
      <app-overlay-loader v-if="preloader"/>
      <form v-else class="mb-0"
            :class="{'loading-opacity': preloader}"
            ref="form"
            data-url="/transportations/save">

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="client_id">{{ $t('bill_of_loading') }} <sup class="text-size-20 top-1">*</sup></label>
              <app-input
                  id="client_id"
                  class="margin-right-8"
                  type="search-and-select"
                  :placeholder="$t('bill_of_loading')"
                  :options="billOfLoading"
                  v-model="formData.bill_of_loading"
                  :error-message="$errorMessage(errors, 'bill_of_loading')"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="client_id">{{ $t('client') }} <sup class="text-size-20 top-1">*</sup></label>
              <div class="d-flex align-items-center w-100">
                <app-input
                    id="client_id"
                    class="margin-right-8"
                    type="search-and-select"
                    :placeholder="$t('choose_a_client')"
                    :options="clientOptions"
                    v-model="formData.client_id"
                    :error-message="$errorMessage(errors, 'client_id')"
                />
                <button class="btn btn-primary ml-2" type="button" @click="openClientModal">
                  <app-icon name="plus" :size="16"/>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="driver_id">{{ $t('driver') }} <sup class="text-size-20 top-1">*</sup></label>
              <app-input
                  id="driver_id"
                  type="search-select"
                  v-model="formData.driver_id"
                  :list="drivers"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="beneficiary_id">{{ $t('allowance') }} <sup class="text-size-20 top-1">*</sup></label>
              <app-input
                  id="beneficiary_id"
                  type="search-select"
                  v-model="formData.beneficiary_id"
                  :list="beneficiaries"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="truck_id">{{ $t('truck') }} <sup class="text-size-20 top-1">*</sup></label>
              <app-input
                  id="truck_id"
                  type="search-select"
                  v-model="formData.truck_id"
                  :list="trucks"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="trailer_id">{{ $t('trailer') }} <sup class="text-size-20 top-1">*</sup></label>
              <app-input
                  id="trailer_id"
                  type="search-select"
                  v-model="formData.trailer_id"
                  :list="trailers"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="eta">
                {{ $t('date') }}<sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="date"
                  type="date"
                  :placeholder="$t('enter_date')"
                  v-model="formData.date"
                  :error-message="$errorMessage(errors, 'date')"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group google-places">
              <label for="destination_from">
                {{ $t('destination_from') }} <sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="driver_id"
                  type="search-select"
                  v-model="formData.destination_from"
                  :list="locations"
                  :required="true"
              />
<!--              <app-input-->
<!--                  id="destination_from"-->
<!--                  type="text"-->
<!--                  v-model="formData.destination_from"-->
<!--                  :error-message="$errorMessage(errors, 'destination_from')"-->
<!--              />-->
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group google-places">
              <label for="destination_to">
                {{ $t('destination_to') }} <sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="driver_id"
                  type="search-select"
                  v-model="formData.destination_to"
                  :list="locations"
                  :required="true"
              />
<!--              <app-input-->
<!--                  id="destination_to"-->
<!--                  type="text"-->
<!--                  v-model="formData.destination_to"-->
<!--                  :error-message="$errorMessage(errors, 'destination_to')"-->
<!--              />-->
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="departure_time">
                {{ $t('departure_time') }}<sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="departure_time"
                  type="time"
                  v-model="formData.departure_time"
                  :error-message="$errorMessage(errors, 'departure_time')"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="departure_date">
                {{ $t('departure_date') }}<sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="departure_date"
                  type="date"
                  v-model="formData.departure_date"
                  :error-message="$errorMessage(errors, 'departure_date')"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="arrival_time">
                {{ $t('arrival_time') }}<sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="arrival_time"
                  type="time"
                  v-model="formData.arrival_time"
                  :error-message="$errorMessage(errors, 'arrival_time')"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="arrival_date">
                {{ $t('arrival_date') }}<sup class="text-size-20 top-1">*</sup>
              </label>
              <app-input
                  id="arrival_date"
                  type="date"
                  v-model="formData.arrival_date"
                  :error-message="$errorMessage(errors, 'arrival_date')"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="mawb">
                {{ $t('mawb') }}<sup class="text-size-20 top-1"></sup>
              </label>
              <app-input
                  id="mawb"
                  type="text"
                  v-model="formData.mawb"
                  :error-message="$errorMessage(errors, 'mawb')"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="hawb">
                {{ $t('hawb') }}<sup class="text-size-20 top-1"></sup>
              </label>
              <app-input
                  id="hawb"
                  type="text"
                  v-model="formData.hawb"
                  :error-message="$errorMessage(errors, 'hawb')"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="customs_declaration">
                {{ $t('customs_declaration') }}<sup class="text-size-20 top-1"></sup>
              </label>
              <app-input
                  id="customs_declaration"
                  type="text"
                  v-model="formData.customs_declaration"
                  :error-message="$errorMessage(errors, 'customs_declaration')"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="reference">
                {{ $t('reference') }}<sup class="text-size-20 top-1"></sup>
              </label>
              <app-input
                  id="reference"
                  type="text"
                  v-model="formData.reference"
                  :error-message="$errorMessage(errors, 'reference')"
              />
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label for="shipment_details">{{ $t('shipment_details') }}</label>
              <app-input
                  id="shipment_details"
                  type="textarea"
                  :text-area-rows="3"
                  :placeholder="$t('enter_note')"
                  v-model="formData.shipment_details"
              />
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label for="remarks">{{ $t('remarks') }}</label>
              <app-input
                  id="remarks"
                  type="textarea"
                  :text-area-rows="3"
                  :placeholder="$t('enter_note')"
                  v-model="formData.remarks"
              />
            </div>
          </div>

        </div>
      </form>
      <client-add-edit-modal
          v-if="isClientModalActive"
          :table-id="'client-table'"
          :client-number="clientNumber"
          @closeModal="closeClientModal"
      />
    </template>
  </modal>
</template>
<style>
.pac-container { z-index: 10000; }
</style>
<script>
import {SubmitFormMixins} from "../../../Mixins/billar/SubmitFormMixins";
import {axiosGet, urlGenerator} from "../../../Helpers/AxiosHelper";
import {formDataAssigner} from "../../../Helpers/Helpers";
import {formatDateForServer} from "../../../Helpers/DateTimeHelper";
import DateFunction from "../../../../core/helpers/date/DateFunction";


export default {
  name: "ShipmentCreateEditModal",
  mixins: [SubmitFormMixins],
  props: {
    drivers: {},
    beneficiaries: {},
    trucks: {},
    trailers: {},
    locations: {},
    clientNumber: '',
  },
  data() {
    return {
      formData: {
        eta: DateFunction.getDateFormat(new Date(), 'YYYY-MM-DD'),
      },
      isClientModalActive: false,
      expensePurposeList: [],
      files: [],
      maxFileWarning: false,
      modalId: 'shipment-create-edit-modal',
      clientOptions: {
        url: urlGenerator('client-users'),
        per_page: 10,
        loader: "app-pre-loader",
        modifire: (value) => ({id: value.id, value: value.full_name}),
      },
      billOfLoading: {
        url: urlGenerator('transportations/bol'),
        per_page: 10,
        loader: "app-pre-loader",
        modifire: (value) => ({id: value.bol, value: value.full_name}),
      },
    }
  },
  methods: {
    submitData() {
      if (this.files.length > 1) {
        this.maxFileWarning = true;
        return;
      }
      this.maxFileWarning = false;
      this.formData.date = formatDateForServer(this.formData?.date);
      this.formData.departure_date = formatDateForServer(this.formData?.departure_date);
      this.formData.arrival_date = formatDateForServer(this.formData?.arrival_date);
      let formData = formDataAssigner(new FormData(), this.formData);
      if (this.selectedUrl) {
        this.submitFromFixin('post', 'transportations/update/' + this.formData.id, formData)
      } else {
        this.submitFromFixin('post', 'transportations/save', formData)
      }
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      this.preloader = false;
    },
    openClientModal() {
      this.isClientModalActive = true;
    },
    closeClientModal() {
      this.isClientModalActive = false;
    },
    setConsignee(input){
      this.formData.consignee = input;
    },
  },
  mounted() {
    let vueMethod = this;
    $(document).on('selectedItem', document, function(e, data){
      if(data.field === 'client_id'){
        vueMethod.setConsignee(data.data.value);
      }
    });
    // console.log(this.locations);
    // setTimeout(function(){
    //   $('.google-places').each(function (){
    //     // console.log($(this).find('input'));
    //     // console.log(document.getElementById($(this).find('input').attr('id')));
    //     var twst = new google.maps.places.Autocomplete(document.getElementById($(this).find('input').attr('id')), {
    //       types: ['(cities)'],
    //       componentRestrictions: {country: ['om', 'ae']}
    //     });
    //     console.log(twst);
    //   });
    // }, 500);
  },
}
</script>

<style scoped>

</style>
